module.exports = __webpack_public_path__ + "img/fi-rr-time-half-past.3383c2b5.svg";